export default __webpack_public_path__ + "static/media/char_head_prem_009.5aa15124.png";